export const DURATION = { fast: 300, base: 700, slow: 1200 };
export const DELAY = { 100: 100, 200: 200, 300: 300, 400: 400, 500: 500, 600: 600, 700: 700, 800: 800 };
export const EASING = { base: 'power2.out', dramatic: 'expo.out', bounce: 'back.out(1.7)', linear: 'none' };
export const DISTANCE = { sm: 20, base: 60, lg: 120 };
